import { useEffect } from 'react'


const Start = ({ isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Start__Background'>
                <img src="/img/games/runtogoal/background-1.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
            </div>

            {/* Contenido */}
            <section className="Screen__Start__Container Container-FullHeight">
                <div className="Screen__Start__Container__Info">
                    {/* <img src="/img/page/xolos-five-black.png" className="Screen__Start__Container__Logotipo" alt="Logo" style={{ backgroundColor: 'rgba(255,255,255,1)', padding: '0', borderRadius: '12px' }} /> */}
                    {/* <p className="Screen__Start__Container__Title" style={{ textShadow: '-6px 0 #fff, 0 6px #fff, 6px 0 #fff, 0 -6px #fff', color: '#001d50' }}>BIENVENID@S</p> textShadow: '-6px 0 #1e246a, 0 6px #1e246a, 6px 0 #1e246a, 0 -6px #1e246a' */}
                    <img src="/img/page/xolos-five.png" className="Screen__Start__Container__Logotipo" alt="Logo"/>
                    <p className="Screen__Start__Container__Title" style={{ color: '#fff' }}>BIENVENID@S</p> {/* textShadow: '-6px 0 #1e246a, 0 6px #1e246a, 6px 0 #1e246a, 0 -6px #1e246a' */}
                </div>
            </section>
            
            {/* Pie de página */}
            <div className='Screen__Start__Footer'>
                <p className="text-center FooterCredits" style={{ color: '#000' }}>Hecho con ♥ por Five Digital Minds | 2026</p>
            </div>
        </>
    )
}

export { Start };








{/* Encabezado /}
{/* <div className='Screen__Start__Background'>
    {/*selfieFan?.isActiveWomensMode ? (
        //<img src='/img/games/runtogoal/background-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
    //) : (
        <img src='/img/games/runtogoal/background-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
    //)/}
    <img src='/img/games/runtogoal/background-1.png' className='Screen__Welcome__Background__Image' />
</div>

<section className="Screen__Start__Container Container-FullHeight">
    {/* <div className="Screen__Start__Container__Lines">
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--Red"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--White"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--Red"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--White"></div>
    </div> /}

    <div className="Screen__Start__Container__Info">
        <img src="/img/page/xolos-five.png" className="Screen__Start__Container__Logotipo" alt="Logo" />
        <p className="Screen__Start__Container__Title">BIENVENID@S</p>
    </div>
</section>

<div className='Screen__Start__Footer'>
    <p className="text-center">Hecho con ♥ por Five Digital Minds | 2026</p>
</div> */}